export default "__VITE_ASSET__19f8d715__"